<script setup>
import { useModuleNavigation } from '@/rebuild/hooks/useModuleNavigation';

defineProps({
	reportList: {
		type: Array,
		default: () => []
	}
});

const { viewModule } = useModuleNavigation();
function gotoReport(report) {
	viewModule('esg', report);
}
</script>

<template>
	<div v-if="reportList.length" class="esg-report-wrapper">
		<p class="title">{{ $t('enterprise.esg-report') }}</p>
		<div class="report-wrapper">
			<div class="report-item" v-for="(report, index) in reportList" :key="index" @click="gotoReport(report)">
				<div v-if="report.logoUrl || report.hasCover" class="report-cover">
					<img v-if="report.logoUrl" class="cover-img" :src="report.logoUrl" alt="" />
					<img v-else class="cover-img" v-loadPDF :data-src="report.url || report.fileUrl" alt="" />
					<div class="cover-mask"></div>
				</div>
				<div v-else class="report-cover default-cover">
					<p class="cover-title">
						<span class="text-overflow2">{{ report.subject }}</span>
					</p>
				</div>
				<p class="text-overflow report-title">{{ report.subject }}</p>
			</div>
		</div>
	</div>
</template>

<style lang="less" scoped>
.esg-report-wrapper {
	.title {
		color: var(--emphasis-color);
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
	}

	.report-wrapper {
		margin-top: 20px;
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-gap: 16px;

		.report-item {
			width: 100%;
			min-width: 0;
			background: var(--fill-normal-color);

			font-size: 0;
			cursor: pointer;

			.report-cover {
				position: relative;
				width: 100%;
				padding-top: 75%;
				border: 1px solid var(--border-lighter-color);
			}
			.cover-img {
				position: absolute;
				top: 0;
				width: 100%;
				height: 100%;
				background-color: #fff;
				object-fit: cover;
			}
			.cover-mask {
				position: absolute;
				top: 0;
				left: 0;
				z-index: 1;
				width: 100%;
				height: 100%;

				background: rgba(0, 0, 0, 0.03);
			}

			.default-cover {
				background: url(https://image.comein.cn/web/irm/irstore/report-default-cover.png);
				background-size: cover;

				display: flex;
				align-items: center;

				.cover-title {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					width: 100%;
					padding: 8px 20px;
					background: rgba(255, 255, 255, 0.4);
					backdrop-filter: blur(5px);

					color: #2e570c;
					text-align: center;
					font-size: 20px;
					font-weight: 500;
					line-height: 24px;
				}
			}

			.report-title {
				padding: 0 8px;
				color: var(--emphasis-color);
				font-size: 16px;
				font-weight: 500;
				line-height: 40px; /* 150% */
			}
		}
	}
}
</style>
